import { getNextAutoPaymentDate } from "@taabl/common-lib/calculators/autopay";
import { formatDate, getCurrentDate } from "@taabl/common-lib/calculators/date";
import { formatCurrency } from "@taabl/common-lib/calculators/money";
import { getNearestPeriodFromNow } from "@taabl/common-lib/calculators/period";
import { round } from "@taabl/common-lib/utils";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { ListGroup, ListGroupItem } from "react-bootstrap";
import { toast } from "react-toastify";
import { Constants } from "../../libs/Constants";
import { get, getList } from "../../libs/dbFunctions";
import { LoanTransactionModal } from "../EmployeeDashboard/LoanTransactionModal";
import { ListBankAccounts } from "../Settings/ListBankAccounts";

export const EmployeeInfo = ({ user, activeCompany, periods }) => {
  const [transactions, setTransactions] = useState([]);
  const [showTransactions, setShowTransactions] = useState(false);
  const [balance, setBalance] = useState(0);
  const [autopay, setAutoPay] = useState(null);
  const [plan, setPlan] = useState(null);
  const [notice, setNotice] = useState(null);
  const [annualTransfer, setAnnualTransfer] = useState(0);
  const [showNotice, setShowNotice] = useState(false);

  useEffect(() => {
    if (user) {
      loadTransactions();
      loadPlan();
      loadAutoPay();
    }
  }, [user]);

  useEffect(() => {
    if (periods && periods.length > 0) {
      loadNotices();
    }
  }, [periods, balance]);

  const loadNotices = () => {
    let today = getCurrentDate(false);
    let nearestClosingPeriod = getNearestPeriodFromNow(
      periods,
      "periodEnddate"
    );
    let dateDiff = moment
      .utc(nearestClosingPeriod.period.periodEnddate)
      .diff(today, "days");

    setNotice({
      date: moment.utc(nearestClosingPeriod.period.periodEnddate),
      amount: round(balance),
      stopAutopay: dateDiff <= -15 && round(balance) > 0
    });
    setShowNotice(dateDiff <= 0 && round(balance) > 0);
  };
  //load Plan detail for user company
  const loadPlan = async () => {
    try {
      const ESPPDetails = await getList(
        Constants.dbTypes.PLAN_DETAILS,
        {
          id: user.companyId
        }
      );
      if (ESPPDetails && ESPPDetails.length > 0) {
        setPlan(ESPPDetails[0]);
      }
    } catch (e) {
      toast.error(e);
    }
  };
  // Load transactions
  const loadTransactions = async () => {
    try {
      //get contribution record for the user
      let details = await getList(
        Constants.dbTypes.TRANSACTION,
        activeCompany,
        {
          id: user.id,
        }
      );
      if (details && details.results) {
        // sort the transactions based on created date
        details.results.sort((a, b) => b.created - a.created);
        setTransactions(details);
        setBalance(details.balance);
        setAnnualTransfer(details.currentYearTransfer);
      } else {
        setTransactions([]);
        setBalance(0);
        setAnnualTransfer(0);
      }
    } catch (err) {
      console.log(err);
      toast.error("Unable to load transactions");
    }
  };
  // Load auto pay
  const loadAutoPay = async () => {
    try {
      //get contribution record for the user
      let details = await get(Constants.dbTypes.AUTOPAY, user.id);

      if (details) {
        if (details.oneTimeTransfer) {
          setAutoPay({
            amount: details.oneTimeTransfer,
            periodStartdate: getNextAutoPaymentDate()
          });
        } else {
          let record = [];
          for (let key in details) {
            if (key.startsWith('pp_')) {
              record.push({
                ...details[key]
              });
            }
          }
          // Even this is not periods object this works as we have dates in it
          let nearestPeriod = getNearestPeriodFromNow(record);
          if (nearestPeriod && nearestPeriod.period) {
            console.log('nearestPeriod.period', nearestPeriod.period);
            setAutoPay(nearestPeriod.period);
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div>
      <h3>Employee Information</h3>

      <ListGroup className="font-size-2 mb-4">
        <ListGroupItem key="accounts">
          <ListBankAccounts accounts={user?.accounts} />
        </ListGroupItem>
        <ListGroupItem key="salary">
          <b>Salary</b> - {formatCurrency(user.salary || 0)}
        </ListGroupItem>
        <ListGroupItem key="contribution">
          <b>Elected Contribution Amount</b> -{" "}
          {formatCurrency(
            user.contributionAmount * (12 / Number(plan?.purchasePeriod)) || 0
          )}
        </ListGroupItem>
        <ListGroupItem key="transactions">
          <div className="d-flex">
            <b>Transactions</b>
            <LoanTransactionModal
              open={showTransactions}
              onHide={setShowTransactions}
              transactions={transactions}
              balance={balance}
            />
          </div>
        </ListGroupItem>
        <ListGroupItem key="contribution">
          <b>Total Amount Transferred in Current Year </b> -{" "}
          {formatCurrency(annualTransfer)}
        </ListGroupItem>
        <ListGroupItem
          className={notice?.stopAutopay ? "text-danger" : ""}
          key="notices"
        >
          <b> Payment Notice</b> -{" "}
          {showNotice && (
            <>
              {`${formatDate(notice.date, Constants.DATEFORMAT.MMDDYYYY)}`}{" "}
              {formatCurrency(notice.amount)}
            </>
          )}
        </ListGroupItem>

        <ListGroupItem key="suggestedAmount">
          <b>Suggested Transfer</b> -{" "}
          {autopay && (
            <>
              {`${formatDate(
                autopay.periodStartdate,
                Constants.DATEFORMAT.MONYYYY
              )}`}{" "}
              {formatCurrency(autopay.amount)}
            </>
          )}
        </ListGroupItem>
      </ListGroup>
    </div>
  );
};
